import { IS_DEBUG } from '@utilities/browser';

const maxEvents = 20;

class ImpressionHandler {
  #impressions = new Set<Record<string, any>>();
  #method: (impressions: Record<string, any>[]) => void;

  private constructor(method: (impressions: Record<string, any>[]) => void) {
    this.#method = method;
    document.addEventListener('visibilitychange', () => {
      document.visibilityState === 'hidden' && this.send();
    });
  }

  add = (impression: Record<string, any>) => {
    if (IS_DEBUG) {
      this.#method([impression]);
      return;
    }

    this.#impressions.add(impression);
    if (this.#impressions.size >= maxEvents) {
      this.send();
    }
  };

  send = () => {
    if (!this.#impressions.size) return;

    this.#method(Array.from(this.#impressions));
    this.#impressions.clear();
  };

  static readonly #handlers = new Map<string, ImpressionHandler>();
  static readonly getInstance = (key: string, method?: (impressions: Record<string, any>[]) => void) => {
    if (!ImpressionHandler.#handlers.has(key) && method) {
      ImpressionHandler.#handlers.set(key, new ImpressionHandler(method));
    }

    return ImpressionHandler.#handlers.get(key);
  };
}

export default ImpressionHandler;
